import { Bell, PanelLeft } from 'lucide-react';

import { TopBarUser } from '@/components/common/TopBarUser';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import useAuth from '@/hooks/useAuth';
import { ROUTES } from '@/utils/constants';

interface ServiceTopBarProps {
  onToggleSidebar: () => void;
}

export const ServiceTopBar = ({ onToggleSidebar }: ServiceTopBarProps) => {
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-40 h-14 border-b border-border bg-card/95 backdrop-blur">
      <div className="flex h-full items-center gap-3 px-4">
        <Button variant="ghost" size="icon" onClick={onToggleSidebar} aria-label="Toggle sidebar">
          <PanelLeft className="h-5 w-5" />
        </Button>

        <div className="flex-1">
          <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-xs">
            <span className="font-semibold text-muted-foreground">CRM</span>
            <span className="text-muted-foreground">/</span>
            <span className="font-bold text-foreground" aria-current="page">
              Service
            </span>
          </nav>
        </div>

        <Popover>
          <PopoverTrigger asChild>
            <Button variant="ghost" size="icon" className="relative" aria-label="Notifications">
              <Bell className="h-5 w-5" />
            </Button>
          </PopoverTrigger>
          <PopoverContent align="end" className="w-80 p-0">
            <div className="border-b border-border px-3 py-2 text-sm font-bold">Notifications</div>
            <p className="px-3 py-6 text-center text-sm text-muted-foreground">
              You&apos;re all caught up.
            </p>
          </PopoverContent>
        </Popover>

        <Badge
          variant="outline"
          className="hidden border-warning bg-warning/30 text-foreground sm:inline-flex"
        >
          DEV
        </Badge>

        <TopBarUser profileRoute={ROUTES.SERVICE_PROFILE} roleLabel={user?.jobRole} />
      </div>
    </header>
  );
};
